import { Component, HostListener, OnInit  } from '@angular/core';
import { AuthService } from '../../features/auth/auth.service';
import { Router, NavigationEnd } from '@angular/router';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-header',
  imports: [NgIf],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})

export class HeaderComponent implements OnInit {
  menuOpen = false;
  showHeader = true;

  constructor(private authService: AuthService, private router: Router) {}

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.showHeader = !event.urlAfterRedirects.includes('/error-404');
      }
    });
  }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }
  
  @HostListener('document:click', ['$event'])
  handleOutsideClick(event: Event) {
    const target = event.target as HTMLElement;
    const clickedInsideMenu = target.closest('.menu-container') || target.closest('.side-menu');
    if (!clickedInsideMenu) {
      this.menuOpen = false;
    }
  }
  

  goToHome() {
    this.menuOpen = false;
    this.router.navigate(['/home']);
  }

  goToProfile() {
    this.menuOpen = false; 
    this.router.navigate(['/profile']);
  }

  onLogout(): void {
    this.authService.revokeToken(localStorage.getItem('refresh_token') || ''); 
  }
}